import { Record, Map } from 'immutable';

const defaultValues = {
  allowMultiple: true,
  collapsibleItems: new Map(),
};

export default class Collapsible extends Record(defaultValues, Collapsible) {
  constructor(values) {
    super({
      ...values,
      collapsibleItems: values && values.collapsibleItems
                        ? values.collapsibleItems : defaultValues.collapsibleItems,
    });
  }

  findCollapsibleItem(itemKey) {
    return this.collapsibleItems.find((item, key) => {
      return `${ key }` === `${ itemKey }` || undefined;
    });
  }

  updateCollapsibleItems(itemKey) {
    if (this.findCollapsibleItem(itemKey) === undefined) {
      return this.collapsibleItems.set(`${ itemKey }`, true);
    }
    return this.collapsibleItems;
  }

  isCollapsed(itemKey) {
    return this.collapsibleItems.get(`${ itemKey }`);
  }

  toggleCollapsibleItem(itemKey) {
    if (this.isCollapsed(itemKey)) {
      return this.collapsibleItems.set(`${ itemKey }`, false);
    }
    return this.collapsibleItems.set(`${ itemKey }`, true);
  }

  toggleSingleItemCollapsible(itemKey) {
    let collapsibleItems = this.toggleCollapsibleItem(itemKey);

    collapsibleItems.forEach((value, key) => {
      if (`${ key }` !== `${ itemKey }`) {
        collapsibleItems = collapsibleItems.set(`${ key }`, true);
      }
    });
    return collapsibleItems;
  }

  openCollapsibleItem(itemKey) {
    return this.collapsibleItems.set(`${ itemKey }`, false);
  }

  closeCollapsibleItem(itemKey) {
    return this.collapsibleItems.set(`${ itemKey }`, true);
  }
}
